/**
 * Created by lycheng on 2017/11/23.
 * 用户信息相关接口
 */
import 'babel-polyfill'
import { config } from 'config'
import { cookie } from 'js/libs/utils-cookie'
var Base64 = require('js-base64').Base64

/**
 * 判断用户是否登陆
 * @returns {Promise}
 */
function checkLogin () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/user/getUserinfo',
      dataType: 'json',
      async: false,
      cache: false,
      success: function (result) {
        resolve({
          code: result.code,
          data: result.data && result.data.uid
        })
      },
      error: function () {
        resolve({})
      }
    })
  })
}

function getUserinfo ({async = true} = {}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/user/getUserinfo',
      dataType: 'json',
      async: async,
      cache: false,
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

function logout () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: `${config.API}ajax/login/logout`,
      dataType: 'json',
      cache: false,
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 获取未读消息数量
 *
 * @param params
 * @returns {Promise}
 */
function getUnReadMsgCount () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: `/herapi/message/count?t=${(new Date()).getTime()}`,
      type: 'get',
      dataType: 'json',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 判断用户下是否有应用
 * @returns {Promise}
 */
function checkUidApp ({async = true} = {}) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: `/herapi/user/checkUidApp`,
      type: 'get',
      async: async,
      cache: false,
      dataType: 'json',
      success: function (result) {
        resolve(result)
      },
      error: function () {
        resolve({})
      }
    })
  })
}

/**
 * 判断用户是否实名认证
 */
function checkUserCertificate (config) {
  return getUserinfo(config).then(function (result) {
    if (result.flag) {
      let userinfo = result.data
      let certificate
      if (userinfo.certificateType) {
        switch (userinfo.certificateStatus) {
          case 0:
          case '0': {
            certificate = {
              code: 0,
              flag: true,
              data: {
                flag: false,
                status: userinfo.certificateStatus,
                type: userinfo.certificateType
              },
              desc: '实名认证未通过'
            }
            break
          }
          case 2:
          case '2': {
            certificate = {
              code: 0,
              flag: true,
              data: {
                flag: false,
                status: userinfo.certificateStatus,
                type: userinfo.certificateType
              },
              desc: '实名认证审核中'
            }
            break
          }
          default : {
            certificate = {
              code: 0,
              flag: true,
              data: {
                flag: true,
                status: userinfo.certificateStatus,
                type: userinfo.certificateType
              },
              desc: '实名认证审核通过'
            }
          }
        }
      } else {
        certificate = {
          code: 0,
          flag: true,
          data: {
            flag: false
          },
          desc: '未实名认证'
        }
      }
      return certificate
    } else {
      return result
    }
  })
}

/**
 * 判断是否为公益用户
 * @returns {Promise}
 */
function isWelfare () {
  return new Promise(function (resolve, reject) {
    let accountId = cookie.get('account_id')
    $.ajax({
      type: 'get',
      url: `/herapi/welfare/sign`,
      success: function (result) {
        resolve({
          flag: 0,
          data: result.data
        })
      },
      data: {
        ref: Base64.encode(accountId)
      },
      error: function (result) {
        resolve(result)
      }
    })
  }).catch(function (reason) {
    console.log('catch:', reason)
  })
}

/**
 * 实名认证后申请1024嘉宾票
 */
function applyTicket () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'post',
      url: '/herapi/user/ticketApply',
      success: function (result) {
        if (result.flag) {
          resolve()
        } else {
          reject(result.desc)
        }
      },
      error: function (result) {
        reject(new Error('申请失败，请重试！'))
      }
    })
  })
}

/**
 * 是否已申请1024嘉宾票
 */
function isApply () {
  return new Promise(function (resolve, reject) {
    $.ajax({
      type: 'get',
      url: '/herapi/user/is_ticket_apply',
      success: function (result) {
        if (result.flag) {
          resolve(result.data)
        } else {
          reject(result.desc)
        }
      },
      error: function (result) {
        reject(new Error('申请失败，请重试！'))
      }
    })
  })
}

/**
 * aes加密
 */
function aesEncry (uid) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: '/herapi/user/encrypt?uid=' + uid,
      dataType: 'json',
      async: false,
      cache: false,
      success: function (result) {
        resolve({
          code: result.code,
          data: result.data
        })
      },
      error: function () {
        resolve({})
      }
    })
  })
}
export {
  checkLogin,
  getUserinfo,
  logout,
  getUnReadMsgCount,
  checkUidApp,
  checkUserCertificate,
  isWelfare,
  applyTicket,
  isApply,
  aesEncry
}



// WEBPACK FOOTER //
// ./src/js/api/user.js